import * as React from "react"
const LaserGun = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    transform="scale(-1 1) rotate(-45)"
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      fill="#1d1d1b"
      d="M10.64 22.93a8.71 8.71 0 0 0-3.22-2A7.7 7.7 0 0 1 4.8 20c-.1-.19-.16-.66.12-.85a19 19 0 0 1 8-4.5c5.1-1.4 7.31-1.12 7.91-.93a10.71 10.71 0 0 1 1.47.65s2.18-2.22 8.43-2.25 9.07 2.69 9.07 2.69S43.61 12 44 11.8a1.15 1.15 0 0 1 1.5.28 24.86 24.86 0 0 1 .85 4.38 11 11 0 0 0 1.78-.16c0-.09-.59-4-.34-4.09s3.53.25 3.56.59 0 1 .12 1.72a5.76 5.76 0 0 0 .25 1.09l1.88-.12a2.5 2.5 0 0 1 2.4-2.25c2.22-.25 3.63 1.62 3.28 3.84s-2.65 2-3.18 1.85a2.06 2.06 0 0 1-.82-.44L53.64 20a22.27 22.27 0 0 0 1.22 1.88c.4.5.72.59.65.87s-2 3.63-2.37 3.5a11.72 11.72 0 0 1-2.09-2.84c-.57-1-.94-1.75-.94-1.75l-1.35 1.25a28.55 28.55 0 0 0 1.82 4C51.64 28.8 52 29 51.76 29.3s-4.62.31-5.68.35-2 0-2 0-.56 2.5-4.25 4.32a15.78 15.78 0 0 1-6.28 1.81s-.5 4.81-1.72 5.62-4.35.79-4.35.79a52.16 52.16 0 0 0 .07 5.28c.18 2.22.75 3.75-1 4.47s-7.79.43-9.54.21-3.81-1.35-3.5-3.15 3.88-12.56 3.88-12.56a27.32 27.32 0 0 1-7.94-3.25C6.42 31.08 7 26.86 10.64 22.93z"
    />
    <path
      fill="#92a0d1"
      d="M8.17 19.15c.05-.28 3.31-2.19 6.25-3.13s4.94-.78 4.78-.59a37.72 37.72 0 0 0-5.06 3.87c-1.69 1.78-2.22 2.53-2.31 2.41s-1.13-1.6-2.13-1.78-1.56-.6-1.53-.78z"
    />
    <path
      fill="#696a9b"
      d="M17.45 18.86a22.08 22.08 0 0 1 11.13-5c4.65-.56 8.12.1 10.72 2.69s3.62 7.16 3.71 8.72a9 9 0 0 1-.37 3 19.51 19.51 0 0 0-1.91-2.59c-.22 0-.56.22-.56.43s2.06 3 1.94 3.29-.6 1.43-.78 1.46-2.16-3.59-2.33-3.65-.59 0-.62.19 2.22 4 2.22 4-1 .78-1.1.72-2.25-4-2.44-4-.71.25-.68.37 2.43 3.94 2.31 4.06-1.16.69-1.22.57-2.44-4-2.62-4-.72.4-.69.5 2.44 3.71 2.25 3.84-.94.41-1 .28-2.27-3.13-2.41-3.13-.81.38-.78.54 2.16 2.81 2 2.9a4 4 0 0 1-.93.19 27.23 27.23 0 0 0-2.1-2.84c-.18 0-.68.18-.68.28s1.68 2.56 1.59 2.65a5.69 5.69 0 0 1-1.16.22A19.87 19.87 0 0 0 29.26 32c-.18 0-1 .28-.9.41s1.5 2.22 1.31 2.31a36.3 36.3 0 0 1-8.59.25c-4.5-.38-8.44-2-10-3.31S9 29.08 10.26 26.9a40.9 40.9 0 0 1 7.19-8.04z"
    />
    <path
      fill="#e7413e"
      d="M40.86 15.65c.15-.16 3.15-2.22 3.15-2a24.57 24.57 0 0 0 2.07 8.22c1.84 4.12 3.06 5.93 3 6s-3.94.12-3.94.12a19.25 19.25 0 0 0-1.22-7.65 15.11 15.11 0 0 0-3.06-4.69z"
    />
    <path
      fill="#85bfe9"
      d="M46.7 17.43a3.09 3.09 0 0 1 1.53-.1c.13.13.22.66.75 1.88s.69 1.65.69 1.65l-1.44.94a10.83 10.83 0 0 1-1.53-4.37z"
    />
    <path
      fill="#f2910d"
      d="M49.05 13.71c0-.22 1.4-.1 1.46 0a31.93 31.93 0 0 0 1.22 4.69 32.53 32.53 0 0 0 2.53 4.6c0 .19-.9 1.62-1 1.53a18.55 18.55 0 0 1-3.21-5.78 28.66 28.66 0 0 1-1-5.04z"
    />
    <path
      fill="#85bfe9"
      d="M52.33 16.46c0-.16 1.25-.13 1.25-.13a2.35 2.35 0 0 0 .37 1l.44.63s-1.06 1.12-1.22 1a2.94 2.94 0 0 1-.84-2.5z"
    />
    <path
      fill="#cbe7f5"
      d="M56.45 14.36a1.77 1.77 0 0 1 1.75 2.32 1.53 1.53 0 0 1-2.78.59c-1.03-1.16-.94-3.06 1.03-2.91z"
    />
    <path
      fill="#f2910d"
      d="M29 36.74c.05-.08 2.56-.31 2.56-.31s-1 3.72-1.12 3.84a6.87 6.87 0 0 1-2.47.34A6.35 6.35 0 0 1 29 36.74z"
    />
    <path
      fill="#e7413e"
      d="M19.48 36.61a14 14 0 0 0 3.44.32c2.13 0 3.63-.19 3.63-.19a13.43 13.43 0 0 0-.85 3.19c-.15 1.53-.28 2.34-.28 2.34A26.36 26.36 0 0 0 23 39.71c-.18 0-.47.72-.4.84s2.75 2.75 2.78 2.91.06 2.19.15 2.81.19 1.5.19 1.5-3.5-3.62-3.65-3.62-.44.81-.44.81 4.28 4.15 4.28 4.4.16 1.25-.06 1.25a1.45 1.45 0 0 1-.57 0c-.12-.06-4.31-4.37-4.5-4.4s-.59.5-.53.68 3.88 3.69 3.69 3.75a8.06 8.06 0 0 1-1.25 0 39.5 39.5 0 0 0-3.34-3c-.22 0-.69.68-.63.78s2.53 2.25 2.53 2.25a22.22 22.22 0 0 1-4.37-.47c-1.22-.41-1.31-1.06-1.22-1.47s3.6-11.73 3.82-12.12z"
    />
    <g fill="#1d1d1b">
      <path d="M23.64 38.68c-.08-.07.25-.66.37-.6s1.07.78 1 1.1-.19.59-.29.56-.89-.91-1.08-1.06zM22.55 42c0-.24 2.21 2 2.21 2.13s.16 1.21 0 1.18a20.32 20.32 0 0 1-2.43-2.25c-.16-.2.22-.91.22-1.06zM18.3 21.36A33.71 33.71 0 0 1 20.11 25c-.1.19-.47.53-.63.34a29.12 29.12 0 0 1-2.06-3.62 1.58 1.58 0 0 1 .88-.36zM19.86 19.71c0-.11.72-.44.9-.41a28.57 28.57 0 0 1 2.5 4.94.73.73 0 0 1-.71.44c-.13-.07-2.69-4.82-2.69-4.97zM22.73 17.86c0-.1.82-.5 1.13-.37a24.2 24.2 0 0 1 2.34 4.66c-.06.21-.84.59-1.06.37s-2.53-4.31-2.41-4.66zM26 17.8c.19-.12.72-.4.85-.28A20.46 20.46 0 0 1 28.3 21c-.1.22-.69.59-.88.44S26 17.8 26 17.8zM32.42 14.9a8.28 8.28 0 0 1 3.06.56c1.41.44 2.07.84 2.1 1.06s-.22 1-.35 1a22.74 22.74 0 0 0-2.5-1c-1.12-.31-2.25-.25-2.4-.44s-.13-1.08.09-1.18z" />
    </g>
  </svg>
)
export default LaserGun
